import './mail-info.component.ajscss';

import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IContact } from '@commons/models/contact';
import { IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';
import moment from 'moment';

import templateUrl from './mail-info.template.html';

class MailInfoCtrl implements IComponentController {
  responseId: string;
  contactNumber: string;
  dialedNumber: string;
  waitedTime: string;

  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly contactDeprecatedService: IContactDeprecatedService
  ) {}

  $onInit(): void {
    this.$log.info('[MailInfoCtrl] loaded');
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => {
        this.contactNumber = contact.phoneNumber;
        this.dialedNumber = contact.dialedNumber;
        this.waitedTime = this.buildWaitedTime(contact);
      },
      error => this.$log.error(error)
    );
  }

  private buildWaitedTime(contact: IContact): string {
    let waitedMoment = moment.unix(Math.round(contact.waitedTime / 1000)).utc();
    return this.$i18next.t('agent:contact.info.waited_time', {
      minutes: waitedMoment.minutes(),
      seconds: waitedMoment.seconds(),
    });
  }
}

export class MailInfo implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['$log', '$i18next', 'contactDeprecatedService', MailInfoCtrl];
}

export default 'contactMailInfo';
